import { authApi } from 'container/authApi';
import { AuthRepository } from 'repository/AuthRepository';

export const authRepository = new AuthRepository(authApi);
